import { connect } from 'react-redux'
import RiderJoinRequestTable from '../../components/riders/RiderJoinRequestTable'
import * as actions from '../../state/actions/riders'
import { getRidersList } from '../../state/reducers/riders'
import { IRiderObject, IStoreState, IRiderFilters, IOptServiceMembership, IUpdateServiceMemberships } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    orgId: state.organizations.currentOrgId,
    searchQuery: state.riderSearch.query,
    riders: getRidersList(state.riders),
    totalItems: state.riders.metadata.total
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchRiders: (filters: IRiderFilters) => {
      return dispatch(actions.getManyRiderJoinRequest(filters))
    },
    approve: (rider: IRiderObject) => {
      const payload: IUpdateServiceMemberships = {
        id: rider.id,
        memberships: rider.serviceMemberships
          ? rider.serviceMemberships.map(membership => {
              return {
                id: membership.id,
                serviceId: membership.service.id,
                status: 'active'
              }
            })
          : ([] as IOptServiceMembership[])
      }
      return dispatch(actions.updateRiderServiceMemberships(payload))
    },
    notApprove: (rider: IRiderObject) => {
      // dispatch action of not approve                              `
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderJoinRequestTable)



// WEBPACK FOOTER //
// ./src/containers/riders/RiderJoinRequestTable.ts